import { makeAutoObservable } from 'mobx';
import { InterestRateResponse } from '../../api/Loans';
import { InterestRateRange } from '../../config/Constants';

export class InterestRates {
  rates: Map<string, number>;

  constructor(rates: Map<string, number>) {
    makeAutoObservable(this);
    this.rates = rates;
  }

  get range() {
    if (this.rates.size === 0 || (this.rates.size === 1 && this.rates.values().next().value === 0.0)) {
      return InterestRateRange.NO_INTEREST;
    } else if (this.rates.size === 1) {
      return InterestRateRange.FIXED_RATE;
    } else {
      return InterestRateRange.VARIABLE;
    }
  }

  static fromApi(apiData: InterestRateResponse[]): InterestRates {
    const rates: Map<string, number> = new Map(
      apiData.map(rate => {
        // null date allowed for FIXED_RATE
        return [rate.date, rate.rate];
      })
    );
    return new InterestRates(rates);
  }

  toApi(): InterestRateResponse[] {
    return Array.from(this.rates, ([date, rate]): InterestRateResponse => ({
      date: date,
      rate: rate,
    }));
  }
}
